

export const validateOrder = (client, company) => {
    if (company.type !== 'delivery' && (!client || !client.number)) {
        return false;
    }
    return true;
};